import { gql } from '@apollo/client';

export const DELETE_ENDPOINT = gql`
  mutation DeleteEndpoint($where: EndpointWhereUniqueInput!) {
    deleteEndpoint(where: $where) {
      id
    }
  }
`;
